export const initialise = () => {
    modalClickAwayClose()
    
    if (!document.body.classList.contains('bio')) return
    repositionModals()
}

const modalClickAwayClose = () => {
    document.body.addEventListener('click', (e) => {
        const target = e.target as HTMLElement

        if (target.classList.contains('attrax-popup-modal') && !target.classList.contains('attrax-popup-modal__inner')) {
            target.classList.add('attrax-popup-modal--hidden')
        }
    })
}

const repositionModals = () => {
    const modals = document.querySelectorAll<HTMLElement>(`
        .attrax-social-hub-profile-widget .attrax-popup-modal,
        .attrax-user-profile-contact-buttons-widget__sendcv-modal
    `)

    modals.forEach(modal => {
        document.body.appendChild(modal)
    })
}